import React, { useEffect, useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {
    Button,
    Checkbox,
    colors,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormLabel,
    Hidden,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial, useStylesAutoSafe
} from '../../../../St/Reports/UseStyle';

import RestInfoDialog from "../../../Invs/BackEnd/models/RestInfo/RestInfoDialog";
import AccountSearch from "../../../../components/controls/AccountsSearch";

export default function SarfTwreedHead(props) {
    const {
        AutoOptions,
        rptParams,
        onChangeData,
        onChangeAutoData,
        typeTwreed,
        onChangeAutoCost,
        valueAutos,
        IsSarf,
        SafesEmp,
        optionsSafes,
        prevent,
        setInfoData,
        infoData,
        accountsOptions,
        handleIconSearchAccount,
        handleInputSearchAccount,
        searchAccountText
    } = props;

    const { t } = useTranslation(["forms"]);

    const clasup = useStylesUp();
    const calsPurch = useStylesAutoPurch();
    const claslbl = useStylesLbl();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    const clasASafe = useStylesAutoSafe();



    const clashd = useStylesHed();
    const clasBA = useStylesBA();
    const clasTD = useStylesTD();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    const handleFocus = (e) => e.target.select();

    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="no"
                        label="رقم الامر"
                        className={clasTF.rootSafe}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        InputProps={{ className: claslbl.clrSafe, readOnly: true }}
                        type="text"
                        name="no" value={rptParams.no} onChange={onChangeData('no')}
                    />
                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="refno"
                        label={t("ref-no")}
                        placeholder="رقم المرجع"

                        className={clasTF.rootSafe}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        InputProps={{ className: claslbl.clrSafe }}
                        type="text"
                        name="refno" value={rptParams.refno} onChange={onChangeData('refno')}
                    />
                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete classes={clasASafe}
                        value={valueAutos.Type_Cost}
                        labelPlacement=""
                        onChange={(event, newValue) => { onChangeAutoCost('Type_Cost', newValue) }}
                        id="controllable-states-demo" size="small"
                        options={typeTwreed}
                        getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
                        // style={{  }}
                        disableClearable
                        renderInput={(params) => <TextField {...params} label="'السعر حسب' " variant="outlined" size="small"
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        />}
                    />

                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="date" label={t("date")}
                        className={clasTF.rootSafe}
                        InputProps={{ className: claslbl.clrSafe }}
                        type="date" format="YYYY-MM-DD"
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        name="date" value={rptParams.date} onChange={onChangeData('date')}
                    /></Grid>

                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete classes={clasASafe}
                        value={valueAutos.safe}
                        labelPlacement=""
                        onChange={(event, newValue) => { onChangeAutoData('safe', newValue) }}
                        id="controllable-states-demo" size="small"
                        // options={SafesEmp}
                        options={optionsSafes}
                        getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
                        // style={{  }}
                        disableClearable
                        renderInput={(params) => <TextField {...params} label={t("safe")} variant="outlined" size="small"
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        />}
                    />
                </Grid>

                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete classes={clasASafe}
                        value={valueAutos.branch}
                        onChange={(event, newValue) => {
                            onChangeAutoData("branch", newValue);
                        }}
                        id="combo-box-demo"
                        size="small"
                        options={AutoOptions.Branches}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }

                        style={{}}
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={t("branch")}
                                variant="outlined"
                                InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            />
                        )}

                    />
                </Grid>

                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete classes={clasASafe}
                        value={valueAutos.center}
                        labelPlacement=""
                        onChange={(event, newValue) => { onChangeAutoData('center', newValue) }}
                        id="controllable-states-demo" size="small"
                        options={AutoOptions.center}
                        getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
                        // style={{  }}
                        disableClearable
                        renderInput={(params) => <TextField {...params} label={t("cost-centers")} variant="outlined" size="small"
                            InputLabelProps={{ className: claslbl.clrBlackLblS }} />}
                    />


                </Grid>

                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete classes={clasASafe}
                        value={valueAutos.omla}
                        labelPlacement=""
                        onChange={(event, newValue) => { onChangeAutoData('omla', newValue) }}
                        id="controllable-states-demo" size="small"
                        options={AutoOptions.Omlat}
                        getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
                        // style={{  }}
                        disableClearable
                        renderInput={(params) => <TextField {...params} label={t("currency")} variant="outlined" size="small"
                            InputLabelProps={{ className: claslbl.clrBlackLblS }} />}
                    />


                </Grid>
                <Grid item lg={3} md={3} sm={4} xs={12} style={{ paddingBottom: "0.5rem" }}>
                    {/* <AccountTwreedSelect
                        accounts={AutoOptions?.Accindex}
                        account={valueAutos.acc}
                        name={"الحساب المدين"}
                        onSelect={(newValue) => {
                            onChangeAutoData("acc", newValue);
                        }}
                    /> */}
                     <AccountSearch
                        accounts={accountsOptions}
                        account={valueAutos.acc}
                        disabled={false}
                        onSelect={(newValue) => {
                            onChangeAutoData("acc", newValue);
                        }}
                        handleIconSearchAccount={handleIconSearchAccount}
                        handleInputSearchAccount={handleInputSearchAccount}
                        searchAccountText={searchAccountText}
                        name={"الحساب المدين"}
                    />
                </Grid>
                <Grid item lg={3} md={3} sm={4} xs={12} style={{ paddingBottom: "0.5rem" }}>
                    {/* <AccountTwreedSelect
                        accounts={AutoOptions?.Accindex}
                        account={valueAutos.acc2}
                        name={"الحساب الدائن"}
                        onSelect={(newValue) => {
                            onChangeAutoData("acc2", newValue);
                        }}
                    /> */}
                     <AccountSearch
                        accounts={accountsOptions}
                        account={valueAutos.acc2}
                        disabled={false}
                        onSelect={(newValue) => {
                            onChangeAutoData("acc2", newValue);
                        }}
                        handleIconSearchAccount={handleIconSearchAccount}
                        handleInputSearchAccount={handleInputSearchAccount}
                        searchAccountText={searchAccountText}
                        name={"الحساب الدائن"}
                    />
                </Grid>
                <Grid item lg={4} md={4} sm={4} xs={12} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="refno"
                        label={t("note")}

                        className={clasTF.rootSafe}
                        InputProps={{ className: claslbl.clrSafe }}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        type="text"
                        name="refno" value={rptParams.notes} onChange={onChangeData('notes')}
                    />
                </Grid>
                <Grid item lg={1} md={1} sm={1} xs={1} >
                    {!prevent && (
                        <Hidden only={["xs"]}>

                            <Button
                                fullWidth
                                autoFocus
                                variant="contained"
                                color="#000"
                                onClick={(e) => {
                                    setInfoData({ open: true, })
                                }}
                                style={{
                                    background: colors.grey[300],
                                    ...{
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                    },
                                }}
                            >
                                {"القيد" + "  "}
                            </Button>
                        </Hidden>
                    )}
                </Grid>
                {!prevent && (
                    <RestInfoDialog
                        infoData={infoData}
                        setInfoData={setInfoData}
                        res_id={rptParams.res_id}
                        branch={rptParams.branch}
                        fromInv={0}
                        proc_id={0}
                    />
                )}
            </Grid>
        </React.Fragment>
    );
}
